// What a landing reserved for a person asks: its exact subject, why, and
// "Approve with passkey", which confirms exactly that subject and then
// approves it (store.approveLanding); or "Approve", when the person's
// account asks for no passkey (Poulpe-686).
import type { ApprovalAsked, Proposal } from '../api/types'
import { useBoardState } from '../store/context'
import { needsServer } from '../components/needsServer'
import { confirmsActions } from '../people/actions'
import { CarriedIssues } from './Carried'
import { partsNamed, reasonText } from './words'

export function Approval({ asked, busy, onApprove }: { asked: ApprovalAsked; busy: boolean; onApprove: () => void }) {
  const { proposals, offline, me } = useBoardState()
  const { subject } = asked
  // Each proposal by every issue it carries (Poulpe-554); one the page does not hold, by its id.
  const proposalLink = (id: string) => {
    const proposal: Proposal | undefined = proposals.get(id)
    return proposal ? <CarriedIssues proposal={proposal} /> : <code>{id}</code>
  }
  return (
    <div className="approval" role="group" aria-label="Approval">
      <p className="approval-ask">Main moves only once a person approves exactly this:</p>
      <dl className="approval-subject">
        <dt>Commit</dt>
        <dd>
          <code>{subject.commit}</code>
        </dd>
        <dt>Tree</dt>
        <dd>
          <code>{subject.tree}</code>
        </dd>
        <dt>Proposals</dt>
        <dd>
          {subject.proposals.map((id) => (
            <span key={id}>{proposalLink(id)}</span>
          ))}
        </dd>
        <dt>Policy</dt>
        <dd>version {subject.policy_version}</dd>
        <dt>Evidence</dt>
        <dd>
          {subject.evidence.length === 0 ? (
            <span className="muted">none</span>
          ) : (
            subject.evidence.map((id) => (
              <code key={id} title="Receipt">
                {id}
              </code>
            ))
          )}
        </dd>
      </dl>
      {asked.reasons.length > 0 && (
        <ul className="approval-reasons">
          {asked.reasons.map((reason, i) => (
            <li key={i}>{reasonText(reason)}</li>
          ))}
        </ul>
      )}
      {asked.stale && (
        <p className="approval-stale">
          An approval of another subject was refused: its {partsNamed(asked.stale.differs)} differed. This is the subject now asked.
        </p>
      )}
      <div className="form-actions">
        <button type="button" className="button button-primary" disabled={busy || offline} {...needsServer(offline)} onClick={onApprove}>
          {busy ? 'Approving…' : confirmsActions(me) ? 'Approve with passkey' : 'Approve'}
        </button>
      </div>
    </div>
  )
}
